"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnumValues = void 0;
/* eslint-disable no-restricted-globals */
function getEnumValues(enumeration) {
    return Object.keys(enumeration)
        .filter((k) => isNaN(Number(k)))
        .map((k) => enumeration[k]);
}
exports.getEnumValues = getEnumValues;
//# sourceMappingURL=utils.js.map